import router from '@/router';
import logger from '@/logger';
import Api from './api';

export default {
  getProjectList: async ({ commit, rootGetters, dispatch }) => {
    const orgId = rootGetters.orgId;
    commit('setProjectListStatus', 'Fetching');
    if (router.currentRoute.query.projectId) {
      dispatch('select', router.currentRoute.query.projectId);
    } else {
      dispatch('deselect');
    }
    try {
      const res = await Api.getProjectList(orgId);
      commit('setProjectList', res.data);
      commit('setProjectListStatus', 'Fetched');
    } catch (err) {
      if (err.response.status === 403) {
        dispatch('users/logout', {}, { root: true });
      }
      commit('setProjectListErrMessage', err.message);
    }
  },
  createProject: async ({ commit }, payload) => {
    const { orgId, projectName } = payload;
    try {
      const res = await Api.postProject(payload);
      commit('addProject', {
        ...res.data,
        orgId,
        name: projectName,
      });
    } catch (err) {
      logger.log(err);
    }
  },
  select: ({ commit, dispatch }, projId) => {
    commit('setProjectId', projId);
  },
  deselect: ({ commit }) => {
    commit('setProjectId', null);
  },
  clear: ({ commit }) => {
    commit('CLEAR');
  },
  async update({ commit }, payload) {
    commit('UPDATING', payload);
    const { _id } = payload;
    try {
      await Api.update(_id, payload);
      commit('UPDATED', payload);
    } catch (error) {
      commit('UPDATE_ERROR', { ...payload, error });
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/projects/actions.js